import ScreenshotOverlay from './screenshot-overlay';

export default class ScreenshotOverlayGantt extends ScreenshotOverlay {
    constructor(screenshot, onClick) {
        super(screenshot, onClick);

        this.text = 'Want to meet all the deadlines? Schedule a personal demo.';
        this.buttonText = 'Request a <i>demo</i>';
        this.buttonColor = 'blue';
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/screenshot-overlay-gantt.js